var map = {
	"./Vector.svg": 2144,
	"./bug.svg": 9048,
	"./dark.svg": 4860,
	"./dragon.svg": 4488,
	"./electric.svg": 2370,
	"./fairy.svg": 8830,
	"./fighting.svg": 7927,
	"./fire.svg": 346,
	"./flying.svg": 6032,
	"./ghost.svg": 4581,
	"./grass.svg": 5345,
	"./ground.svg": 3030,
	"./ice.svg": 9213,
	"./normal.svg": 9729,
	"./poison.svg": 2934,
	"./psychic.svg": 753,
	"./rock.svg": 5284,
	"./steel.svg": 7549,
	"./water.svg": 9717
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5324;